import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinIssueCloneRoute: InvariantJiraRoute = {
	name: 'legacy-gin-issue-clone',
	path: '/(secure|issue)/CloneIssue(\\w*)([!%]?[\\w]*).jspa',
};
